import {
  defaultFont,
  secondaryColor,
} from '../../styles/style';

const style = {
  downloadRelay: {
    ...defaultFont,
    padding: '10px 0',
    fontSize: '16px',
  },
  downloadRelay__text: {},
  downloadRelay__text_link: {
    'color': `${secondaryColor}!important`,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export default style;
